import { Directive, Input, ContentChildren, ElementRef } from '@angular/core';
import { NgxCardNumberTemplate, NgxCardNameTemplate, NgxCardExpiryTemplate, NgxCardCvcTemplate } from './inputs';
var defaultPlaceholders = {
    number: '•••• •••• •••• ••••',
    name: 'Full Name',
    expiry: '••/••',
    cvc: '•••',
};
var defaultMessages = {
    validDate: 'valid\nthru',
    monthYear: 'month/year',
};
var NgxCard = (function () {
    function NgxCard(element) {
        this.element = element;
        this.formatting = true; // optional - default true
        // if true, will log helpful messages for setting up Card
        this.debug = false; // optional - default false
    }
    Object.defineProperty(NgxCard.prototype, "messages", {
        get: function () {
            return this._messages;
        },
        set: function (_messages) {
            this._messages = Object.assign({}, defaultMessages, _messages);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgxCard.prototype, "placeholders", {
        get: function () {
            return this._placeholders;
        },
        set: function (_placeholders) {
            this._placeholders = Object.assign({}, defaultPlaceholders, _placeholders);
        },
        enumerable: true,
        configurable: true
    });
    NgxCard.prototype.ngAfterViewInit = function () {
        new Card({
            form: this.element.nativeElement,
            container: this.container,
            width: this.width,
            formSelectors: {
                numberInput: this.findSelectors(this.numbers),
                expiryInput: this.findSelectors(this.expiries),
                cvcInput: this.findSelectors(this.cvcs),
                nameInput: this.findSelectors(this.names),
            },
            formatting: this.formatting,
            messages: this.messages,
            placeholders: this.placeholders,
            masks: this.masks,
            debug: this.debug,
        });
    };
    NgxCard.prototype.findSelectors = function (list) {
        return list.map(function (template) { return template.elementRef.nativeElement.tagName.toLowerCase() + '[name="' + template.name + '"]'; })
            .join(', ');
    };
    return NgxCard;
}());
export { NgxCard };
NgxCard.decorators = [
    { type: Directive, args: [{
                selector: '[card]',
            },] },
];
/** @nocollapse */
NgxCard.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
NgxCard.propDecorators = {
    'container': [{ type: Input },],
    'width': [{ type: Input, args: ['card-width',] },],
    'messages': [{ type: Input },],
    'placeholders': [{ type: Input },],
    'masks': [{ type: Input },],
    'formatting': [{ type: Input },],
    'debug': [{ type: Input },],
    'numbers': [{ type: ContentChildren, args: [NgxCardNumberTemplate, { descendants: true },] },],
    'names': [{ type: ContentChildren, args: [NgxCardNameTemplate, { descendants: true },] },],
    'expiries': [{ type: ContentChildren, args: [NgxCardExpiryTemplate, { descendants: true },] },],
    'cvcs': [{ type: ContentChildren, args: [NgxCardCvcTemplate, { descendants: true },] },],
};
;
//# sourceMappingURL=card.js.map